import React from 'react'
import { LinearProgress, Paper, Typography } from '@material-ui/core'

const LoadingState = ({ title, error }) => (
    <Paper style={{ padding: 24 }} aria-busy={!error}>
        {!!title && <Typography variant="h6" gutterBottom>{title}</Typography>}
        {error ? <Typography role="alert">The data could not be loaded. Please try again.</Typography> : (
            <div role="status" aria-live="polite">
                <Typography gutterBottom>Loading...</Typography>
                <LinearProgress aria-label={typeof title === 'string' ? `Loading ${title}` : 'Loading data'} />
            </div>
        )}
    </Paper>
)

export default LoadingState
